import React from "react";


function LegalWarning() {
    return (
        <>
            <div
                className="page-header section-dark"
                style={{
                    backgroundColor:"#4d4d4d",
                }} />

            <style>
                {".page-header {height: 80px; min-height: unset}"}
            </style>

            <div className="Legal-Page">
                <h1>Aviso Legal.</h1>
                <p>
                    El presente Aviso Legal regula el uso de la página web <a href="https://oiprocesos.com/"> www.oiprocesos.com</a>  (en adelante la Página) 
                    titularidad de Outsourcing Ingeniería de Procesos, con domicilio en Parque Empresarial San Fernando Avda. de Castilla, 2
                    28830 San Fernando de Henares (Madrid); CIF nº B-88396734; inscrita en el Registro Mercantil de Madrid. Tomo 39185. Folio 1. Hoja nº M-696120. Inscripción 1ª y con dirección de correo
                    electrónico <a href="mailto:comunicacion@oiprocesos.com"> comunicacion@oiprocesos.com</a>
                </p>
                <p>
                    Para la utilización de la Página se requiere la aceptación expresa del usuario de todas y cada una de las cláusulas que se
                    indican en el presente Aviso Legal, así como cada una de las advertencias o cláusulas específicas que se establezcan
                    para la contratación de determinados servicios, productos o uso de zonas de la Página.
                </p>
                <p>
                    En caso de no aceptar las cláusulas establecidas en el presente Aviso Legal, el usuario deberá abstenerse de acceder y/o
                    utilizar los servicios y/o contenidos puestos a su disposición en la Página, procediendo a abandonar la misma.
                 </p>

                <h2>USO DE LA PÁGINA</h2>
                <p>
                    El usuario se obliga a no utilizar la Página para la realización de actividades contrarias a las leyes, a la moral, al orden
                    público y, en general, a hacer un uso conforme a las condiciones establecidas en el presente Aviso Legal. Asimismo, se obliga a
                    no realizar actividades publicitarias o de explotación comercial remitiendo mensajes que utilicen una identidad falsa.
                </p>
                <p>
                    La Compañía actúa exclusivamente como responsable de la Página en su condición de prestador de un servicio de información sobre
                    sus propios servicios, no haciéndose responsable de los contenidos que, en contravención a las presentes condiciones generales,
                    los usuarios pudieran enviar o publicar, siendo el usuario el único responsable de la veracidad y licitud de los mismos.
                </p>
                <p>
                    La Compañía podrá interrumpir el servicio de la Página que esté siendo utilizado por el usuario y resolver de modo inmediato la relación con el
                    usuario si detecta un uso de la Página o de cualquiera de los servicios que en el mismo se ofertan que pueda considerar contrario a lo
                    expresado en el presente Aviso Legal.
                </p>

                <h2>PROPIEDAD INTELECTUAL E INDUSTRIAL</h2>
                <p>
                    La totalidad de esta Página: texto, imágenes, marcas, gráficos, logotipos, botones, archivos de software, combinaciones de colores, así como la
                    estructura, selección, ordenación y presentación de sus contenidos, se encuentra protegida por las leyes sobre Propiedad Intelectual e Industrial,
                    quedando prohibida su reproducción, distribución, comunicación pública y transformación, salvo para uso personal y privado.
                </p>
                <p>
                    La Compañía no garantiza que los contenidos sean precisos o libres de error o que el libre uso de los mismos por el usuario no infrinja los derechos
                    de terceras partes. El buen o mal uso de esta página y de sus contenidos está bajo la responsabilidad del usuario.
                </p>
                <p>
                    Asimismo, queda prohibida la reproducción, retransmisión, copia, cesión o redifusión, total o parcial, de la información contenida en la Página,
                    cualquiera que fuera su finalidad y el medio utilizado para ello, sin autorización previa de la Compañía.
                </p>

                <h2>ENLACES O LINKS</h2>
                <p>
                    La Página puede incluir enlaces o links a sitios de terceros. Las páginas pertenecientes a terceros no han sido revisadas ni son objeto de controles por
                    parte de la Compañía. En cualquier caso, la Compañía no podrá ser considerada responsable de los contenidos de estos sitios web ni de las medidas que se
                    adopten relativas a su privacidad o al tratamiento de sus datos de carácter personal.
                </p>
                <p>
                    La Compañía recomienda la lectura detenida de las condiciones de uso y la política de privacidad de estos sitios.
                </p>
                <p>
                    En caso de estar interesado en activar un enlace a alguna de las páginas de la Compañía deberá comunicarlo, obteniendo el consentimiento expreso para crear
                    el enlace. La Compañía se reserva el derecho de oposición a la activación de enlaces con su sitio web.
                </p>

                <h2>MENORES DE EDAD</h2>
                <p>
                    La Compañía recuerda a los usuarios mayores de edad, que tengan a su cargo menores, que será de su exclusiva responsabilidad determinar qué servicios y/o
                    contenidos son no apropiados para la edad de estos últimos.
                </p>
                <p>
                    La Compañía les informa que existen programas informáticos que permiten filtrar y bloquear el acceso a determinados contenidos y servicios, de tal forma que
                    los padres o tutores, por ejemplo, pueden decidir cuáles son los contenidos y servicios de Internet a los que los menores pueden tener acceso y cuáles no.
                </p>

                <h2>RESPONSABILIDADES</h2>
                <p>
                    La Compañía no será responsable directa ni subsidiariamente de:
                </p>
                <p>
                    -La calidad del servicio, la velocidad de acceso, el correcto funcionamiento ni la disponibilidad ni continuidad de funcionamiento de la Página.
                    <br/>
                    -Los daños que puedan causarse en los equipos del usuario por la utilización de la Página.
                    <br />
                    -Los casos en que un tercero, quebrantando las medidas de seguridad establecidas, acceda a los mensajes o los utilice para la remisión de virus informáticos.
                    <br />
                    -Los vicios y defectos de toda clase de los contenidos transmitidos, difundidos, almacenados o puestos a disposición.
                    <br />
                    -La licitud, fiabilidad y utilidad de los contenidos que los usuarios transmitan con la utilización de la página o de los servicios en él ofertados, así como tampoco su veracidad o exactitud. La Compañía no controla la utilización que los usuarios hacen de la Página, ni garantiza que lo hagan conforme a lo establecido en el presente Aviso Legal.
                </p>
                <p>

                    A título enunciativo y con carácter no limitativo, el usuario será responsable de:
                </p>
                <p>
                    -De los contenidos introducidos por ellos, especialmente de los datos e informaciones introducidos y enviados a la Compañía por medio de la Página o en la Página.
                    <br />
                    -De la realización de cualquier tipo de actuación ilícita, lesiva de derechos, nociva y/o perjudicial.
                    <br />
                    -De la custodia de su nombre de usuario y password, no debiéndolo comunicar a terceras personas, en orden a la evitación de suplantaciones de identidad o facilitación de datos no veraces o incorrectos.
                </p>

                <h2>FUERO</h2>
                <p>
                    El presente Aviso Legal se encuentra redactado en castellano, y se encuentra sometido a la legislación española vigente. Para cualquier tipo de controversia derivada de la utilización de los servicios ofrecidos o de los contenidos propios de la Página las partes, con la aceptación del clausulado establecido en el presente Aviso Legal se someterán a los
                    Tribunales y Juzgados competentes de Madrid.
                </p>
                <p>Última actualización: 01 de Octubre de 2020</p>
            </div>
        </>
    )
}

export default LegalWarning;